import { FiltersOperator } from './../../widgets/filters/api/filters-operator.api';
import { QueryFilterParameter } from './../../widgets/filters/models/query-filter-parameter.model';
import { KpiData } from './../home/models/kpi-data.model';
import { Injectable } from '@angular/core';
import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { FiltersOutput, FilterOutput, FilterInput, FiltersOutputNew, FilterValue } from 'src/app/models/filter-objects';
import { DataFOveriviewDto, OverviewForecastSelectionOption, ForecastOverviewTableData, ForecastOverviewTableIssueResponse, ForecastOverviewPram, ForecastDeepDiveMultiPram } from 'src/app/models/forecast/fc-overview-models';
import { DataFDeepDiveDto, DeepDiveListTable, DeepDiveUpdateComment, UpdateForecastElemtData, DataFDeepDiveNewDto, ForecastElementUpdateNewData, ForecastElementUpdateMultiData } from 'src/app/models/forecast/fc-deepdive-models';
import { Observable } from 'rxjs';
import { TableQueryOptions, QuerySortParams } from 'src/app/helpers/grid-helper';
import { ReturnFlags, ReturnFlag } from 'src/app/models/return-flag';
import { ForecastDetailedPostingsChartDto } from './detailed-postings/forecast-detailed-postings.models';
import { TopdownAdjustmentData, TopdownAdjustmentParam, TopdownAdjustmentList, TopdownAddAdjustmentParam, ForecastAjstGroupsData, TopdownAdjustmentDataNew, TopdownAdjustmentParamNew, UpdateTopDown, ForecastPeriod, ForecastDataExport } from 'src/app/models/forecast/topdown-adjustment.model';
import { IForecastParametersData } from 'src/app/models/forecast/stat-fc-deepdive-models';
import { TableString } from 'src/app/models/table-string.model';
import { ActivityData, ActivityDataNew } from './activity/models/activity-data.model';
import { UtilsService } from 'src/app/services/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ForecastService {
  private destroy = new Subject<void>();

  constructor(private baseService: BaseService) { }

  // Main.

  getOverviewData(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: FilterOutput[]): Observable<DataFOveriviewDto> {
    let url = `forecast/GetOverviewData?filters.Action=${Action}&filters.Unit=${Unit}&filters.UnitOfMeasure=${UnitOfMeasure}&filters.SettingGroupId=${SettingGroupId}`;
    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].settingId=${filtersOptions.settingId}&filters.filtersOptions[${i}].fieldValue=${filtersOptions.fieldValue}`;
      }
    }
    return this.baseService.get(url);
  }

  // GetForecastDeepDiveMulti

  GetForecastDeepDiveMulti(params: ForecastOverviewPram): Observable<DataFOveriviewDto> {
    let url = `forecast/GetForecastDeepDiveMulti`;
    return this.baseService.post(url, JSON.stringify(params));
  }

  SelectForecastDeepDiveTableMultiData(params: ForecastDeepDiveMultiPram): Observable<any> {
    let url = `forecast/SelectForecastDeepDiveTableMultiData`;
    return this.baseService.post(url, JSON.stringify(params));
  }

  SelectForecastDeepDiveTableMultiDataCount(params: ForecastDeepDiveMultiPram): Observable<any> {
    let url = `forecast/SelectForecastDeepDiveTableMultiDataCount`;
    return this.baseService.post(url, JSON.stringify(params));
  }


  // New.

  GetOverviewDataNew(params: ForecastOverviewPram): Observable<DataFOveriviewDto> {
    let url = `forecast/GetOverviewDataNew`;
    return this.baseService.post(url, JSON.stringify(params));
  }

  // Statistical.

  getOverviewDataStatistical(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutput: QueryFilterParameter[]): Observable<any> {
    let url = `forecast/GetOverviewDataStatistical?filters.Action=${Action}&filters.Unit=${Unit}&filters.UnitOfMeasure=${UnitOfMeasure}&filters.SettingGroupId=${SettingGroupId}`;

    if (filterOutput && filterOutput.length > 0) {
      for (let i = 0; i < filterOutput.length; i++) {
        const filtersOptions = filterOutput[i];
        url += `&filters.filtersOptions[${i}].fieldName=${filtersOptions.fieldName}&filters.filtersOptions[${i}].value=${filtersOptions.value}`;
      }
    }
    return this.baseService.get(url);
  };
  // Main.

  getOverviewTableData(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: FilterOutput[],filterValue:FilterValue[]): Observable<any> {
    let url = `forecast/GetOverviewTable`;

    let filters: ForecastOverviewPram = new ForecastOverviewPram();
    filters.Action = Action;
    filters.Unit = Unit;
    filters.UnitOfMeasure = UnitOfMeasure;
    filters.SettingGroupId = SettingGroupId;
    filters.filtersOptions = filterOutout;
    filters.filterValue=filterValue
    return this.baseService.post(url, JSON.stringify(filters)).pipe(takeUntil(this.destroy));;
  }

  cancelPreviousRequests() {
    this.destroy.next();
    this.destroy.complete();
    this.destroy = new Subject<void>();
  }

  // Statistical.

  getForecastingOverviewTableStatistical(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: QueryFilterParameter[]): Observable<any> {
    let url = `forecast/GetOverviewTableStatistical?filters.Action=${Action}&filters.Unit=${Unit}&filters.UnitOfMeasure=${UnitOfMeasure}&filters.SettingGroupId=${SettingGroupId}`;
    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].fieldName=${filtersOptions.fieldName}&filters.filtersOptions[${i}].value=${filtersOptions.value}`;
      }
    }
    return this.baseService.get(url);
  }

  getDeepDiveTableData(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: FilterOutput[], requestOptions?: RequestOptions): Observable<any> {
    let url = `forecast/GetDeepDiveTable?filters.Action=${Action}&filters.Unit=${Unit}&filters.UnitOfMeasure=${UnitOfMeasure}&filters.SettingGroupId=${SettingGroupId}`;
    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].settingId=${filtersOptions.settingId}&filters.filtersOptions[${i}].fieldValue=${filtersOptions.fieldValue}`;
      }
    }
    return this.baseService.get(url,requestOptions);
  }

  GetDeepDiveTableById(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: FilterOutput[], requestOptions?: RequestOptions): Observable<any> {
    let url = `forecast/GetDeepDiveTableNewById`;
    var filters = { SettingGroupId: SettingGroupId, filtersOptions: filterOutout, Action: Action, Unit: Unit, UnitOfMeasure: UnitOfMeasure };
    return this.baseService.post(url, filters,requestOptions);
  }

  getDeepDiveTableDataStatistical(Action: string = '', Unit: string = '', SettingGroupId: number = 0, UnitOfMeasure: string, filterOutout: FilterOutput[]): Observable<any> {
    let url = `forecast/GetDeepDiveTableStatistical?filters.Action=${Action}&filters.Unit=${Unit}&filters.UnitOfMeasure=${UnitOfMeasure}&filters.SettingGroupId=${SettingGroupId}`;
    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].settingId=${filtersOptions.settingId}&filters.filtersOptions[${i}].fieldValue=${filtersOptions.fieldValue}`;
      }
    }
    return this.baseService.get(url);
  }

  getDataForForecastParametersTbl(forecastObjectId: number): Observable<any> {
    let url = `forecast/GetDataForStatisticalForecastingForecastParametersTbl?forecastObjectId=${forecastObjectId}`;
    return this.baseService.get(url);
  }

  saveStatisticalFcAndParams(fcObjectIds: number[], updateForecast: boolean,
    updateParams: boolean): Observable<any> {
    let url = `forecast/SaveStatFcParameters?updateForecast=${updateForecast}&updateParams=${updateParams}`;
    return this.baseService.post(url, fcObjectIds);
  }

  updateOrCreateForecastParametersObject(objectToUpdate: IForecastParametersData): Observable<any> {
    let url = `forecast/UpdateObjectForecastParametersTbl`;
    return this.baseService.post(url, objectToUpdate);

  }

  getIssueResponseDatasource(requestOptions?: RequestOptions): Observable<ForecastOverviewTableIssueResponse[]> {
    const url = `forecast/GetIssueResponses`;
    return this.baseService.get(url,requestOptions);
  }

  updateOverviewTableData(data: ForecastOverviewTableData[], requestOptions?: RequestOptions): Observable<any> {
    const url = 'forecast/UpdateForecastOverviewTableData';
    return this.baseService.post(url, data, requestOptions);
  }

  deleteOverviewTableData(data: ForecastOverviewTableData[], requestOptions?: RequestOptions): Observable<any> {
    const url = 'forecast/DeleteForecastOverviewTableData';
    return this.baseService.post(url, data, requestOptions);
  }

  /* get forecast overview filter data */
  GetFcFilters(SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<FilterInput[]> {
    let url = `forecast/GetFcFilters?filters.settingGroupId=${SettingGroupId}`;

    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].settingId=${filtersOptions.settingId}&filters.filtersOptions[${i}].fieldValue=${filtersOptions.fieldValue}`;
      }
    }
    return this.baseService.get(url);
  }

  /* get forecast overview filter data */
  GetFcFiltersNew(SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<FilterInput[]> {
    let url = `forecast/GetFcFiltersNew`;
    let filters: ForecastOverviewPram = new ForecastOverviewPram();
    filters.SettingGroupId = SettingGroupId;
    filters.filtersOptions = filterOutout;
    return this.baseService.post(url, JSON.stringify(filters));
  }

  SelectForecastDeepDiveMultiFilters(SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<FilterInput[]> {
    let url = `forecast/SelectForecastDeepDiveMultiFilters`;
    let filters: ForecastOverviewPram = new ForecastOverviewPram();
    filters.SettingGroupId = SettingGroupId;
    filters.filtersOptions = filterOutout;
    return this.baseService.post(url, JSON.stringify(filters));
  }

  getFcFiltersStatistical(SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<FilterInput[]> {
    let url = `forecast/GetFcFiltersStatistical?filters.settingGroupId=${SettingGroupId}`;

    if (filterOutout && filterOutout.length > 0) {
      for (let i = 0; i < filterOutout.length; i++) {
        const filtersOptions = filterOutout[i];
        url += `&filters.filtersOptions[${i}].settingId=${filtersOptions.settingId}&filters.filtersOptions[${i}].fieldValue=${filtersOptions.fieldValue}`;
      }
    }
    return this.baseService.get(url);
  }

  /* get forecast Quntity and selection option */
  GetSelectionOption(action: string = '', actionType: string = ''): Observable<OverviewForecastSelectionOption> {
    let url = `forecast/GetSelection?action=${action}&actionType=${actionType}`;
    return this.baseService.get(url);
  }

  /* get forecast deepdive selection or some comon selection */
  GetCommonSelection(action: string = '', actionType: string = '', requestOptions?: RequestOptions): Observable<object> {
    let url = `forecast/GetCommonSelection?action=${action}&actionType=${actionType}`;
    return this.baseService.get(url, requestOptions);
  }

  /* get forecast Quntity and selection option */
  GetTagSelectionOption(action: string = '', actionType: string = ''): Observable<object> {
    let url = `forecast/GetTagBoxSelection?action=${action}&actionType=${actionType}`;
    return this.baseService.get(url);
  }

  /* get forecast Quntity and selection option */
  GetDeepDiveData(id: string = '', type: string = ''): Observable<DataFDeepDiveDto> {
    let url = `forecast/GetDeepDiveData?id=${id}&type=${type}`;
    return this.baseService.get(url);
  }

  /* get forecast Quntity and selection option */
  GetDeepDiveDataNew(id: string = '', type: string = '', requestOptions?: RequestOptions): Observable<DataFDeepDiveNewDto> {
    
    let url = `forecast/GetDeepDiveDataNew`;
    return this.baseService.post(url, { id: id, type: type }, requestOptions);
  }

  //Statistical
  GetDeepDiveDataStatistical(id: string = '', type: string = ''): Observable<DataFDeepDiveDto> {
    let url = `forecast/GetDeepDiveDataStatistical?id=${id}&type=${type}`;
    return this.baseService.get(url);
  }

  //Forecast Statistical
  GetStatFcDeepDiveDataStatistical(id: string = '', type: string = ''): Observable<any> {
    let url = `forecast/GetStatFcDeepDiveDataStatistical?id=${UtilsService.getURLHelper(id)}&type=${type}`;
    return this.baseService.get(url);
  }
  /* get forecast list data */
  GetDeepDivelst(id: number = 0, type: string = '', productid: string = ''): Observable<DeepDiveListTable> {
    let url = `forecast/GetDeepDivelst?productid=${productid}`;
    return this.baseService.get(url);
  }

  /* Update Forecast Comment */
  UpdateForecastComment(ForcstObjt: DeepDiveUpdateComment, requestOptions?: RequestOptions): Observable<ReturnFlags> {
    let url = `forecast/UpdateForecastComment?obj.ClientComment=${ForcstObjt.ClientComment}&obj.ClientResponse=${ForcstObjt.ClientResponse}&obj.ForecastObjectClientId=${ForcstObjt.ForecastObjectClientId}&obj.PermanentComment=${ForcstObjt.PermanentComment}&obj.ClientOtherComment=${ForcstObjt.ClientOtherComment}`;
    return this.baseService.get(url, requestOptions);
  }

  SelectCaptionChart(): Observable<Object> {
    let url = `forecast/SelectCaptionChart`;
    return this.baseService.post(url);
  }

  /* Update Forecast Comment */
  UpdateForecastBasicManualAdjustment(ForcstObjt: UpdateForecastElemtData): Observable<ReturnFlags> {
    let url = `forecast/UpdateForecastBasicManualAdjustment`;
    return this.baseService.post(url, JSON.stringify(ForcstObjt));
  }

  /* Update Forecast Multi */
  UpdateForecastBasicMultiManualAdjustment(ForcstObjt: ForecastElementUpdateMultiData): Observable<ReturnFlags> {
    let url = `forecast/UpdateForecastBasicMultiManualAdjustment`;
    return this.baseService.post(url, JSON.stringify(ForcstObjt));
  }

  /* Update Forecast Comment */
  UpdateForecastBasicManualAdjustmentNew(ForcstObjt: ForecastElementUpdateNewData, requestOptions?: RequestOptions): Observable<ReturnFlags> {
    let url = `forecast/UpdateForecastBasicManualAdjustmentNew`;
    return this.baseService.post(url, JSON.stringify(ForcstObjt), requestOptions);
  }

  getDeepDiveData(action: string, filters: TableQueryOptions) {

    if (!filters.sort) {
      const sort = new QuerySortParams();
      sort.selector = 'ProductId';
      sort.desc = false;
      filters.sort = sort;
    }

    let url = `forecast/GetOverviewDeepDive?action=${action}&skip=${filters.skip}&take=${filters.take}`;
    url += `&sort.selector=${filters.sort.selector}&sort.desc=${filters.sort.desc}`;

    if (filters.columnsFilters && filters.columnsFilters.length > 0) {
      for (let i = 0; i < filters.columnsFilters.length; i++) {
        const columnFilter = filters.columnsFilters[i];

        url += `&columnsFilters[${i}].fieldName=${columnFilter.fieldName}&columnsFilters[${i}].value=${columnFilter.value}&columnsFilters[${i}].operation=${columnFilter.operation}`;
      }
    }
    return this.baseService.get(url);
  }


  getDeepDiveAutocomleteData(objectId: string): Observable<string[]> {
    const url = `forecast/GetAutoComplete?objectId=${objectId}`;
    return this.baseService.get(url);
  }

  GetAccuracyFilters(filtersOptions: FiltersOutput, skipFilters: boolean = false): Observable<FilterInput[]> {
    let url = `forecast/GetAccuracyFilters`;
    let newData: FiltersOutputNew = new FiltersOutputNew();

    if (!skipFilters) {

      newData.SettingGroupId = filtersOptions.settingGroupId;
      newData.filtersOptions = filtersOptions.filters;
      return this.baseService.post(url, newData);
    }
    else {
      return this.baseService.post(url, newData);
    }

  }

  GetAccuracyV2Filters(filtersOptions: FiltersOutput, skipFilters: boolean = false): Observable<FilterInput[]> {
    let url = `forecast/GetAccuracyFiltersV2`;
    let newData: FiltersOutputNew = new FiltersOutputNew();

    if (!skipFilters) {

      newData.Action = filtersOptions.action;
      newData.SettingGroupId = filtersOptions.settingGroupId;
      newData.filtersOptions = filtersOptions.filters;
      return this.baseService.post(url, newData);
    }
    else {
      return this.baseService.post(url, newData);
    }

  }

  GetAccuracyData(Action: string = '', SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<any> {



    let url = `forecast/GetAccuracyData`;
    let newData: FiltersOutputNew = new FiltersOutputNew();
    newData.Action = Action;
    newData.SettingGroupId = SettingGroupId;
    newData.filtersOptions = filterOutout;
    return this.baseService.post(url, newData);
  }

  GetAccuracyDataV2(Action: string = '', SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<any> {
    let url = `forecast/GetAccuracyDataV2`;
    let newData: FiltersOutputNew = new FiltersOutputNew();
    newData.Action = Action;
    newData.SettingGroupId = SettingGroupId;
    newData.filtersOptions = filterOutout;
    return this.baseService.post(url, newData);
  }

  GetAccuracyList(Action: string = '', SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<any> {

    let url = `forecast/GetAccuracyList`;
    let newData: FiltersOutputNew = new FiltersOutputNew();
    newData.Action = Action;
    newData.SettingGroupId = SettingGroupId;
    newData.filtersOptions = filterOutout;
    return this.baseService.post(url, newData);
  }

  GetAccuracyListV2(Action: string = '', SettingGroupId: number = 0, filterOutout: FilterOutput[]): Observable<any> {
    let url = `forecast/GetAccuracyListV2`;
    let newData: FiltersOutputNew = new FiltersOutputNew();
    newData.Action = Action;
    newData.SettingGroupId = SettingGroupId;
    newData.filtersOptions = filterOutout;
    return this.baseService.post(url, newData);
  }

  GetDetailedPostingsChartData(productId: string) {
    return this.baseService.post<ForecastDetailedPostingsChartDto[]>(
      "forecast/GetDetailedPostingsChartDataNew", { id: productId }
    );
  }


  GetDetailedPostingsData(productId: string) {
    return this.baseService.post(
      "forecast/GetDetailedPostingsDataNew", { id: productId }
    );
  }


  GetForecastObjectClientIds() {
    return this.baseService.get<string[]>("forecast/GetForecastObjectClientIds");
  }

  GetTopdownAdjustmentLoadData() {
    return this.baseService.post<TopdownAdjustmentData>("forecast/TopdownAdjustmentLoadData");
  }

	public getTopdownAdjustmentLoadDataNew(
		action: string = 'defalut',
		requestOptions?: RequestOptions
	) {
		return this.baseService.get<TopdownAdjustmentDataNew>("forecast/TopdownAdjustmentLoadDataNew?action=" + action, requestOptions);
	}

  GetTopdownAdjustmentListData(Param: TopdownAdjustmentParam) {
    return this.baseService.post<TopdownAdjustmentList>("forecast/TopdownAdjustmentList", Param);
  }

  GetTopdownAdjustmentListDataNew(Param: TopdownAdjustmentParam) {
    return this.baseService.post<TopdownAdjustmentList>("forecast/TopdownAdjustmentListNew", Param);
  }

	public getTopdownAdjustmentListDataSearchNew(
		topdownAdjustmentParam: TopdownAdjustmentParamNew,
		requestOptions?: RequestOptions
	) {
		return this.baseService.post<TopdownAdjustmentList>("forecast/TopdownAdjustmentListSearchNew", topdownAdjustmentParam, requestOptions);
	}

  GetTopdownAdjustmentLoadGroupData(groupname: string) {
    return this.baseService.post<ForecastAjstGroupsData[]>("forecast/TopdownAdjustmentLoadGroupData?groupname=" + groupname);
  }

  AddUpdateAdjustmentData(Param: TopdownAddAdjustmentParam) {
    return this.baseService.post<ReturnFlag>("forecast/UpdateTopdownAdjustment", Param);
  }
  AddUpdateAdjustmentDataNew(Param: UpdateTopDown) {
    return this.baseService.post<ReturnFlag>("forecast/UpdateTopdownAdjustmentNew", Param);
  }

  private readonly _getActivityListSelectionDataRequestEndpoint: string = "GetActivityListSelectionData";

  public getActivityListSelectionData(): Observable<TableString[]> {
    let url = `forecast/${this._getActivityListSelectionDataRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getForecastElementSelectionDataRequestEndpoint: string = "GetForecastElementSelectionData";

  public getForecastElementSelectionData(): Observable<TableString[]> {
    let url = `forecast/${this._getForecastElementSelectionDataRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _createNewActivityRequestEndpoint: string = "CreateNewActivity";

  public createNewActivity(activityObjectClientId: string): Observable<any> {
    let url = `forecast/${this._createNewActivityRequestEndpoint}?activityObjectClientId=${activityObjectClientId}`;

    console.warn("_createNewActivityRequestEndpoint - activityObjectClientId:", activityObjectClientId);

    return this.baseService.post(url);
  }

  private readonly _getActivityListItemsGridDataRequestEndpoint: string = "GetActivityListItemsGridData";

  public getActivityListItemsGridData(activityListId: number): Observable<any> {
    let url = `forecast/${this._getActivityListItemsGridDataRequestEndpoint}?activityListId=${activityListId}`;

    return this.baseService.get(url);
  }

  private readonly _saveActivityListItemGridDataRequestEndpoint: string = "SaveActivityListItemGridData";

  public saveActivityListItemGridData(
    activityListItemsData: any,

    activityListId: number
  ): Observable<any> {
    let url = `forecast/${this._saveActivityListItemGridDataRequestEndpoint}?activityListId=${activityListId}`;

    console.warn("saveActivityListItemGridData - data:", activityListItemsData, activityListId);

    return this.baseService.post(url, activityListItemsData);
  }

  private readonly _deleteActivityListItemGridDataRequestEndpoint: string = "DeleteActivityListItemGridData";

  public deleteActivityListItemGridData(
    activityItem: string,
    activityListId: number
  ): Observable<any> {
    let url = `forecast/${this._deleteActivityListItemGridDataRequestEndpoint}?activityListId=${activityListId}`;

    let body = { activityItem };

    console.warn("deleteActivityListItemGridData - data:", body, activityListId);

    return this.baseService.post(url, body);
  }

  private readonly _saveMultipleActivityListItemsGridDataRequestEndpoint: string = "SaveMultipleActivityListItemsGridData";

  public saveMultipleActivityListItemsGridData(
    activityListItemsData: any[],

    activityListId: number
  ): Observable<any> {
    let url = `forecast/${this._saveMultipleActivityListItemsGridDataRequestEndpoint}?activityListId=${activityListId}`;

    console.warn("saveMultipleActivityListItemsGridData - body:", activityListItemsData, activityListId);

    return this.baseService.post(url, activityListItemsData);
  }

  private readonly _deleteMultipleActivityListItemsGridDataRequestEndpoint: string = "DeleteMultipleActivityListItemsGridData";

  public deleteMultipleActivityListItemsGridData(
    activityItems: string[],
    activityListId: number
  ): Observable<any> {
    let url = `forecast/${this._saveMultipleActivityListItemsGridDataRequestEndpoint}?activityListId=${activityListId}`;

    let body = { activityItems };

    console.warn("deleteMultipleActivityListItemsGridData - body:", body, activityListId);

    return this.baseService.post(url, body);
  }

  private readonly _createActivityRequestEndpoint: string = "CreateActivity";

  public createActivity(activityObjectClientId: string): Observable<{ success: boolean, message: string }> {
    let url = `forecast/${this._createActivityRequestEndpoint}?activityObjectClientId=${activityObjectClientId}`;

    return this.baseService.post(url);
  }

  private readonly _cloneActivityRequestEndpoint: string = "CloneActivity";

  public cloneActivity(activityObjectClientId: string, originalActivityObjectClientId: string): Observable<{ success: boolean, message: string }> {
    let url = `forecast/${this._cloneActivityRequestEndpoint}?activityObjectClientId=${activityObjectClientId}&originalActivityObjectClientId=${originalActivityObjectClientId}`;

    return this.baseService.post(url);
  }

  private readonly _saveActivityRequestEndpoint: string = "SaveActivity";

  public saveActivity(
    activityObjectClientId: string,
    activityData: any
  ): Observable<{ success: boolean, message: string }> {
    let url = `forecast/${this._saveActivityRequestEndpoint}?activityObjectClientId=${activityObjectClientId}`;

    // Properties to ignore.
    const ignoredProperties = [
      "ActivityObjectId",
      "StartDate",
      "EndDate",
      "DeterminationDate",
      "ActivityListName",
      "ForecastElementName",
      "UserName",
      "IsChanged"
    ];

    for (let a = 0; a < ignoredProperties.length; a++) {
      const element = ignoredProperties[a];

      if (activityData.hasOwnProperty(element)) {
        delete activityData[element];
      }
    }

    let body = {
      activityData
    };

    console.warn("saveActivity - body:", body, " - url:", url);

    return this.baseService.post(url, activityData);
  }

  public saveActivityNew(activityData: ActivityDataNew,requestOptions?: RequestOptions
  ): Observable<{ success: boolean, message: string }> {
    let url = `forecast/SaveActivityNew`;

    // Properties to ignore.
    const ignoredProperties = [
      //"ActivityObjectId",
      "StartDate",
      "EndDate",
      "DeterminationDate",
      "ActivityListName",
      "ForecastElementName",
      "UserName",
      "IsChanged"
    ];

    for (let a = 0; a < ignoredProperties.length; a++) {
      const element = ignoredProperties[a];

      if (activityData.hasOwnProperty(element)) {
        delete activityData[element];
      }
    }

    return this.baseService.post(url, activityData,requestOptions);
  }

  private readonly _deleteActivityRequestEndpoint: string = "DeleteActivity";

  public deleteActivity(
    activityData: any
  ): Observable<{ success: boolean, message: string }> {
    let url = `forecast/${this._deleteActivityRequestEndpoint}`;

    console.warn("deleteActivity - data:", activityData);

    return this.baseService.post(url, activityData);
  }


  private readonly _getActivityRequestEndpoint: string = "GetActivity";

  public getActivity(activityObjectClientId: string): Observable<ActivityData> {
    let url = `forecast/${this._getActivityRequestEndpoint}?activityObjectClientId=${activityObjectClientId}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesRequestEndpoint: string = "GetActivities";

  public getActivities(): Observable<any> {
    let url = `forecast/${this._getActivitiesRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesObjectClientIdsRequestEndpoint: string = "GetActivitiesObjectClientIds";

  public getActivitiesObjectClientIds(): Observable<any> {
    let url = `forecast/${this._getActivitiesObjectClientIdsRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getActivityTableDataRequestEndpoint: string = "GetActivityTableData";

  public getActivityTableData(activityObjectClientId: string): Observable<any> {
    let url = `forecast/${this._getActivityTableDataRequestEndpoint}?activityObjectClientId=${activityObjectClientId}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesFiltersRequestEndpoint: string = "GetActivitiesFilters";

  public getActivitiesFilters(filters: QueryFilterParameter[]): Observable<any> {
    let url = `forecast/${this._getActivitiesFiltersRequestEndpoint}`;

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];

        url += (i === 0 ? "?" : "&") + `filters[${i}].fieldName=${filter.fieldName}&filters[${i}].value=${filter.value}&filters[${i}].operation=${filter.operation}`;
      }
    }

    return this.baseService.get(url);
  }

  private readonly _getActivitiesGridDataRequestEndpoint: string = "GetActivitiesGridData";

  public getActivitiesGridData(
    filtersOperator: FiltersOperator
  ): Observable<any> {
    let url = `forecast/${this._getActivitiesGridDataRequestEndpoint}?filters.action=${filtersOperator.overviewFiltersOutput.action}`;

    if (filtersOperator.overviewFiltersOutput.filters) {
      for (let i = 0; i < filtersOperator.overviewFiltersOutput.filters.length; i++) {
        const queryFilterParameter: QueryFilterParameter = filtersOperator.overviewFiltersOutput.filters[i];

        url += `&filters.filters[${i}].fieldName=${queryFilterParameter.fieldName}&filters.filters[${i}].value=${queryFilterParameter.value}&filters.filters[${i}].operation=${queryFilterParameter.operation}`;
      }
    }

    return this.baseService.get(url);
  }

  private readonly _getActivityListRequestEndpoint: string = "GetActivityList";

  public getActivityList(activityListId: number): Observable<any> {
    let url = `forecast/${this._getActivityListRequestEndpoint}?activityListId=${activityListId}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesListsRequestEndpoint: string = "GetActivitiesLists";

  public getActivitiesLists(): Observable<any> {
    let url = `forecast/${this._getActivitiesListsRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesListsNamesRequestEndpoint: string = "GetActivitiesListsNames";

  public getActivitiesListsNames(): Observable<any> {
    let url = `forecast/${this._getActivitiesListsNamesRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getActivitiesListsFiltersRequestEndpoint: string = "GetActivitiesListsFilters";

  public getActivitiesListsFilters(filters: QueryFilterParameter[]): Observable<any> {
    let url = `forecast/${this._getActivitiesListsFiltersRequestEndpoint}`;

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];

        url += (i === 0 ? "?" : "&") + `filters[${i}].fieldName=${filter.fieldName}&filters[${i}].value=${filter.value}&filters[${i}].operation=${filter.operation}`;
      }
    }

    return this.baseService.get(url);
  }

  private readonly _getActivitiesListsGridDataRequestEndpoint: string = "GetActivitiesListsGridData";

  public getActivitiesListsGridData(
    action: string,
    filtersOutput: QueryFilterParameter[]
  ): Observable<any> {
    let url = `forecast/${this._getActivitiesListsGridDataRequestEndpoint}?filters.action=${action}`;

    if (filtersOutput) {
      for (let i = 0; i < filtersOutput.length; i++) {
        const filtersOptions = filtersOutput[i];

        url += `&filters.filters[${i}].fieldName=${filtersOptions.fieldName}&filters.filters[${i}].value=${filtersOptions.value}&filters.filters[${i}].operation=${filtersOptions.operation}`;
      }
    }

    return this.baseService.get(url);
  }

  private readonly _saveActivitiesListsGridDataRequestEndpoint: string = "SaveActivitiesListsGridData";

  public saveActivitiesListsGridData(
    activitiesListData: any,
    originalActivityListName: string | null | undefined = null
  ): Observable<{ success: boolean, message: string }> {
    let originalActivityListNameUrl = originalActivityListName ? `?originalActivityListName=${originalActivityListName}` : "";

    let url = `forecast/${this._saveActivitiesListsGridDataRequestEndpoint}` + originalActivityListNameUrl;

    console.warn("saveActivitiesListGridData - data:", activitiesListData, " url:", url);

    return this.baseService.post(url, activitiesListData);
  }

  private readonly _deleteActivitiesListsGridDataRequestEndpoint: string = "DeleteActivitiesListsGridData";

  public deleteActivitiesListsGridData(
    activitiesListData: any
  ): Observable<{ success: boolean, message: string }> {
    let url = `forecast/${this._deleteActivitiesListsGridDataRequestEndpoint}`;

    console.warn("deleteActivitiesListGridData - data:", activitiesListData);

    return this.baseService.post(url, activitiesListData);
  }

  private readonly _getActivitiesResultsFiltersRequestEndpoint: string = "GetActivitiesResultsFilters";

  public getActivitiesResultsFilters(filters: QueryFilterParameter[]): Observable<any> {
    let url = `forecast/${this._getActivitiesResultsFiltersRequestEndpoint}`;

    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];

        url += (i === 0 ? "?" : "&") + `filters[${i}].fieldName=${filter.fieldName}&filters[${i}].value=${filter.value}&filters[${i}].operation=${filter.operation}`;
      }
    }

    return this.baseService.get(url);
  }

	private readonly _getActivitiesResultsGridDataRequestEndpoint: string = "GetActivitiesResultsGridData";

	public getActivitiesResultsGridData(
		action: string,
		filtersOutput: QueryFilterParameter[],
		requestOptions?: RequestOptions
	): Observable<any> {
		let url = `forecast/${this._getActivitiesResultsGridDataRequestEndpoint}?filters.action=${action}`;

		if (filtersOutput) {
			for (let i = 0; i < filtersOutput.length; i++) {
				const filtersOptions = filtersOutput[i];

				url += `&filters.filters[${i}].fieldName=${filtersOptions.fieldName}&filters.filters[${i}].value=${filtersOptions.value}&filters.filters[${i}].operation=${filtersOptions.operation}`;
			}
		}

		return this.baseService.get(
			url,
			requestOptions
		);
	}

	private readonly _getActivitiesResultsChartDataRequestEndpoint: string = "GetActivitiesResultsChartData";

	public getActivitiesResultsChartData(
		action: string,
		filtersOutput: QueryFilterParameter[],
		requestOptions?: RequestOptions
	): Observable<any> {
		let url = `forecast/${this._getActivitiesResultsChartDataRequestEndpoint}?filters.action=${action}`;

		if (filtersOutput) {
			for (let i = 0; i < filtersOutput.length; i++) {
				const filtersOptions = filtersOutput[i];

				url += `&filters.filters[${i}].fieldName=${filtersOptions.fieldName}&filters.filters[${i}].value=${filtersOptions.value}&filters.filters[${i}].operation=${filtersOptions.operation}`;
			}
		}

		return this.baseService.get(
			url,
			requestOptions
		);
	}

  //#region <Kpi>

  private readonly _getKpiObjectsRequestEndpoint: string = "GetKpiObjects";

  public getKpiObjects(): Observable<any> {
    let url = `forecast/${this._getKpiObjectsRequestEndpoint}`;

    return this.baseService.get(url);
  }

  private readonly _getKpiRequestEndpoint: string = "GetKpi";

  public getKpi(kpiId: number, quantity: number = -1): Observable<KpiData[]> {
    let url = `forecast/${this._getKpiRequestEndpoint}?kpiId=${kpiId}&quantity=${quantity}`;

    return this.baseService.get(url);
  }

  //#endregion </Kpi>

  //#region export forecast data
  GetExportData(data: ForecastDataExport): Observable<any> {
    return this.baseService.post<any>("forecast/GetExportData", data);
  }

  GetExportPeriod() {
    return this.baseService.post<ForecastPeriod[]>("forecast/GetExportPeriod");
  }

  //#endregion

  GetTopdwonHistory(action: string, id: number): Observable<any> {
    return this.baseService.post<any>("forecast/GetTopdownData?action=" + action + "&id=" + id);
  }

  GetExportTopdownData(action: string, id: number): Observable<any> {
    return this.baseService.post<any>("forecast/ExportTopdownData?action=" + action + "&id=" + id);
  }

  ChartTopdownData(id: number): Observable<any> {
    return this.baseService.post<any>("forecast/ChartTopdownData?id=" + id);
  }

  UpdateForecastHistory(id: number, action: string): Observable<any> {
    return this.baseService.post<any>("forecast/UpdateForecastHistory?id=" + id + "&action=" + action);
  }

}
